import axios from 'axios';
import router from './router/router.js'


// 创建 Axios 实例
const instance = axios.create({

   //          baseURL: "http://localhost:8080",     //   本地
  //   baseURL: "http://192.168.0.188:8080", //  192.168.0.188 
          baseURL: "http://dash.prod.freebeatfit.com",//  公司后端服务器
});



// 添加请求拦截器
instance.interceptors.request.use(config => {
    // 从适当的位置获取 Token，例如从本地存储中获取
    const token = localStorage.getItem('token');
  
    // 如果 Token 存在，则将其添加到请求头部中
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  
    return config;
  }, error => {
    return Promise.reject(error);
  });
  

// 添加响应拦截器
instance.interceptors.response.use(response => {
    return response;
  }, error => {
    if (error.response && error.response.status === 401) {
      // Token 验证失败，跳转到登录页面
      router.push('/login');
    }
  
    return Promise.reject(error);
  });


  export default instance;